import BaseCheckbox from '@carvana/showroom-forms/Checkbox';
import type { CheckboxProps } from '@carvana/showroom-forms/Checkbox/Checkbox';
import type React from 'react';
import { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import FilterEvents from '~/constants/srp/events';
import SearchSource from '~/constants/srp/SearchSource';
import { useTrackEvent } from '~/context/srp/SearchAnalyticsContext';
import SearchEventsDataContext from '~/context/srp/SearchEventsDataContext';

const Checkbox: React.FC<CheckboxProps> = styled(BaseCheckbox).attrs({
  className: 'mb-0'
})`
  .checkbox__label {
    color: var(--cvna-color-blue-6);
    width: 100%;
  }
`;

type OwnProps = {
  analyticsAttributes?: Record<string, any>;
  facet: string;
  filter: string | number;
} & CheckboxProps;

export default function FilterCheckbox({
  analyticsAttributes,
  checked,
  facet,
  filter,
  onChange,
  ...rest
}: OwnProps) {
  const { setSearchSource } = useContext(SearchEventsDataContext);
  const [isChecked, setChecked] = useState(checked);
  const trackEvent = useTrackEvent();

  const onChangeHandler: React.ChangeEventHandler<HTMLInputElement> = ev => {
    setChecked(v => !v);

    trackEvent(FilterEvents.engagedFacet, {
      action: `${isChecked ? 'remove' : 'add'} facet`,
      item: 'checkbox',
      label: facet,
      value: filter,
      ...analyticsAttributes
    });

    const t = setTimeout(() => {
      setSearchSource(SearchSource.Facet);
      if (onChange) onChange(ev);
    }, 0);

    return () => {
      clearTimeout(t);
    };
  };

  // Synchronize local state with global state
  useEffect(() => {
    setChecked(checked);
  }, [checked]);

  return (
    <Checkbox
      checked={isChecked}
      data-analytics-id={null}
      onChange={onChangeHandler}
      {...rest}
    />
  );
}
